import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-cloud-icon]',
  template: `
    <svg:path
      d="M8 2.99805C10.1495 2.99814 11.9592 4.45077 12.502 6.42773C14.1256 6.80576 15.335 8.26148 15.335 10C15.3349 11.152 14.8028 12.1803 13.9736 12.8516C13.8723 12.9336 13.7533 12.9788 13.6328 12.9932V13H2.31543V12.9844C2.21325 12.9639 2.11399 12.9216 2.02734 12.8516C1.19788 12.1804 0.665151 11.1522 0.665039 10C0.665039 8.26144 1.87437 6.80572 3.49805 6.42773C4.04083 4.45075 5.85048 2.99806 8 2.99805ZM8 4.33203C6.34488 4.33205 4.96999 5.53851 4.70996 7.12012C4.66073 7.41924 4.41604 7.64753 4.11426 7.67578C2.92821 7.78563 1.99902 8.78491 1.99902 10C1.99913 10.696 2.30535 11.3177 2.79004 11.7461H13.2109C13.6953 11.3177 14.0009 10.6957 14.001 10C14.001 8.78513 13.0725 7.78592 11.8867 7.67578C11.5846 7.6478 11.3393 7.41945 11.29 7.12012C11.03 5.53855 9.65506 4.33213 8 4.33203Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloudIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
